<div class="payer-identity" *ngIf="merchantName">
  <img
    *ngIf="merchantLogoUrl"
    [src]="merchantLogoUrl"
    [alt]="merchantName + ' logo'"
    class="merchant-initials merchant-logo-img payer-identity-logo"
  />
  <span *ngIf="!merchantLogoUrl" class="merchant-initials payer-identity-logo" aria-hidden="true">{{
    initials
  }}</span>
  <div class="payer-identity-name">{{ merchantName }}</div>
</div>
